import React, {useState} from 'react';
import {DocForm} from "./components/DocForm";
import {ICreativeContext, IParsedAdditional, IParsedInvoice, JobState} from "./types/types";
import {DocType, JobStage} from "./constants/constants";
import {AdditionalForm} from "./components/AdditionalForm";
import {Start} from "./components/Start";
import {CreativeForm} from "./components/CreativeForm";
import InvoiceForm from "./components/InvoiceForm";
import {Login} from "./components/Login";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('accessToken'));
    const [title, setTitle] = useState('Загрузка документов');
    const [state, setState] = useState<JobState>({stage: JobStage.START});

    if (!isAuthenticated) {
        return (
            <div className="App">
                <header className="app-header">
                    <h1>Medpoint ORD</h1>
                </header>
                <main className="app-main">
                    <Login onSuccess={() => setIsAuthenticated(true)} />
                </main>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        );
    }

    const handleBackToStart = () => {
        setState({stage: JobStage.START});
    };

    const handleDocGoogle = (data: IParsedAdditional | IParsedInvoice) => {
        const {type} = data;

        switch (type) {
            case DocType.ADDITIONAL:
                setState({stage: JobStage.FORM_ADDITIONAL, data});
                break;
            case DocType.INVOICE:
                setState({stage: JobStage.FORM_INVOICE, data});
                break;
            default:
                setState({stage: JobStage.START});
        }
    };

    const handleStageSelect = (newState: JobState) => {
        switch (newState.stage) {
            case JobStage.ERID_REPORT:
                setTitle('Отчитаться по ERID');
                break;
            case JobStage.FORM_DOC_GOOGLE:
                setTitle('Обработка документа');
                break;
            case JobStage.FORM_ADDITIONAL:
                setTitle('Редактирование дополнительного соглашения');
                break;
            case JobStage.FORM_CREATIVE:
                setTitle(`Создание креатива для ${newState.context.contract_external_name}`);
                break;
            case JobStage.FORM_INVOICE:
                setTitle('Редактирование акта');
                break;
            default:
                setTitle('Главное меню');
        }

        setState(newState);
    };

    return (
        <div className="App">
            <header className="app-header">
                <h1>{title}</h1>
            </header>

            <main className="app-main">
                {state.stage !== JobStage.START &&
                    <button className="button back" onClick={handleBackToStart}>Назад</button>}

                {state.stage === JobStage.START && (
                    <Start onSelect={handleStageSelect}/>
                )}

                {state.stage === JobStage.ERID_REPORT && (
                    <DocForm docContext={DocType.INVOICE} onSuccess={handleDocGoogle}/>
                )}

                {state.stage === JobStage.FORM_DOC_GOOGLE && (
                    <DocForm
                        docContext={(state as {stage: JobStage.FORM_DOC_GOOGLE; docContext: DocType}).docContext}
                        onSuccess={handleDocGoogle}
                    />
                )}

                {state.stage === JobStage.FORM_ADDITIONAL && (
                    <AdditionalForm
                        googleDocData={(state as {
                            stage: JobStage.FORM_ADDITIONAL;
                            data: IParsedAdditional
                        }).data as IParsedAdditional}
                        onSuccess={(context) => handleStageSelect({stage: JobStage.FORM_CREATIVE, context})}
                    />
                )}

                {state.stage === JobStage.FORM_INVOICE && (
                    <InvoiceForm
                        googleDocData={(state as {
                            stage: JobStage.FORM_INVOICE;
                            data: IParsedInvoice
                        }).data as IParsedInvoice}
                    />
                )}

                {state.stage === JobStage.FORM_CREATIVE && (
                    <CreativeForm
                        context={(state as {stage: JobStage.FORM_CREATIVE; context: ICreativeContext}).context}
                    />
                )}
            </main>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

export default App;
